import axios from "axios";
import { rsa, decode } from "../libs/rsa";
import { getLogin } from "../libs/auth";
import { getServerConfigUrl } from "@/service/server";
export const login = ({
  mobile,
  password,
  accountType,
  mobileAreaCode,
  isLink
}) => {
  const res = rsa({
    userKey: mobile
  }, ["userKey"]);
  console.log(res);
  const data = {
    password,
    accountType,
    mobileAreaCode,
    isLink,
    ...res
  };
  return axios.request({
    url: "/api/sso/login",
    data,
    method: "post"
  });
};
//手机验证登录
export const loginWithPhone = data => {
  const res = rsa(data, ["mobile"]);
  return axios.request({
    url: "/api/sso/mobileVerificationLogin",
    data: {
      ...data,
      ...res
    },
    method: "post"
  });
};
//邮箱验证码登录
export const loginWithEmail = data => {
  const res = rsa(data, ["email"]);
  return axios.request({
    url: "/api/sso/emialVerificationLogin",
    data: {
      ...data,
      ...res
    },
    method: "post"
  });
};

// 绑定手机/邮箱
export const bindMobileEmail = data => {
  const res = rsa(data, ["mobile", "email"]);
  return axios.request({
    url: "/api/user/updateLoginAuth",
    method: "post",
    data: {
      ...data,
      ...res
    }
  });
};
export const getUserInfo = () => {
  return axios.request({
    url: "/api/user/info",
    method: "get"
  });
};

// 登录进入单位或登录态刷新时获取翻译服务临时身份。
export const getI18nTokenInfo = () => {
  return axios.request({
    url: "/api/authn/getitt",
    method: "get",
    // 翻译临时令牌获取失败不影响主流程，由调用方静默降级处理。
    headers: {
      nomsg: true
    }
  });
};
export const checkActivated = () => {
  return axios.request({
    url: "/api/gig/instance/checkActivated",
    method: "get"
  });
};
export const updateUserInfo = data => {
  const res = rsa(data, ["mobile", "email"]);
  console.log(data);
  return axios.request({
    url: "/api/user/update",
    method: "post",
    data: {
      ...data,
      ...res
    }
  });
};
export const logout = () => {
  return axios.request({
    url: "/api/sso/logout",
    method: "get"
  });
};
export const getUnreadCount = () => {
  return axios.request({
    url: "message/count",
    method: "get"
  });
};
export const getMessage = () => {
  return axios.request({
    url: "message/init",
    method: "get"
  });
};
export const getContentByMsgId = msg_id => {
  return axios.request({
    url: "message/content",
    method: "get",
    params: {
      msg_id
    }
  });
};
export const hasRead = msg_id => {
  return axios.request({
    url: "message/has_read",
    method: "post",
    data: {
      msg_id
    }
  });
};
export const removeReaded = msg_id => {
  return axios.request({
    url: "message/remove_readed",
    method: "post",
    data: {
      msg_id
    }
  });
};
export const restoreTrash = msg_id => {
  return axios.request({
    url: "message/restore",
    method: "post",
    data: {
      msg_id
    }
  });
};
export const getUserUnit = () => {
  return axios.request({
    url: "/api/user/units",
    method: "get"
  });
};
export const entryUnit = unitId => {
  return axios.request({
    url: "/api/user/entryUnit",
    method: "get",
    params: {
      unitId
    }
  });
};
export const unitsTree = params => {
  return axios.request({
    url: "/api/user/unitsTree",
    method: "get",
    params
  });
};
export const unitsForOig = params => {
  return axios.request({
    url: "/api/user/unitsForOig",
    method: "get",
    params
  });
};
// 禁用密码
export const disablePassword = data => {
  return axios.request({
    url: "/api/user/disablePassword",
    method: "post",
    data
  });
};
//发送手机验证码
export const mobileVerificationCode = async (mobile, captchaVerification, mode, mobileAreaCode) => {
  let decodeMobile = mobile;
  if (mode == "FORGET_PASSWORD" || mode == "SECOND_CONFIRM") {
    if (getLogin()) {
      const res2 = await getEncText({
        mode: "USER_MOBILE"
      });
      if (res2 && res2.data) {
        const mobile = decode(res2.data.retVal);
        if (mobile.indexOf("+") > -1) {
          decodeMobile = mobile.split("-")[1];
        } else {
          decodeMobile = mobile;
        }
        console.log("解密的手机号-----", decodeMobile);
      }
    }
  }
  const res = rsa({
    mobile: decodeMobile
  }, ["mobile"]);
  return axios.request({
    url: "/api/sso/mobileVerificationCode",
    method: "post",
    data: {
      mobileAreaCode,
      mode,
      captchaVerification,
      ...res
    }
  });
};
//发送邮箱验证码
export const emailVerificationCode = async (email, captchaVerification, mode) => {
  let decodeMobile = email;
  if (mode == "FORGET_PASSWORD" || mode == "SECOND_CONFIRM") {
    if (getLogin()) {
      const res2 = await getEncText({
        mode: "USER_EMAIL"
      });
      if (res2 && res2.data) {
        decodeMobile = decode(res2.data.retVal);
      }
    }
  }
  const res = rsa({
    email: decodeMobile
  }, ["email"]);
  return axios.request({
    url: "/api/sso/emailVerificationCode",
    method: "post",
    data: {
      mode,
      captchaVerification,
      ...res
    }
  });
};
export const regist = body => {
  const res = rsa(body, ["mobile", "email"]);
  return axios.request({
    url: "/api/sso/register",
    method: "post",
    data: {
      ...body,
      ...res
    }
  });
};
//二次登录
export const secondConfirmLogin = body => {
  const res = rsa(body, ["userKey"]);
  return axios.request({
    url: "/api/sso/secondConfirmLogin",
    method: "post",
    data: {
      ...body,
      ...res
    }
  });
};
export const wxBindWithRegister = body => {
  const res = rsa(body, ["mobile"]);
  return axios.request({
    url: "/api/sso/register/bind",
    method: "post",
    data: {
      ...body,
      ...res
    }
  });
};
export const resources = appCode => {
  return axios.request({
    url: "/api/resource/user/list",
    method: "get",
    params: {
      appCode
    }
  });
};
export const restPass = data => {
  return axios.request({
    url: "/api/sso/resetPasswordByMobile",
    method: "post",
    data
  });
};
//邮箱验证码修改密码
export const restPassByEmail = data => {
  return axios.request({
    url: "/api/sso/resetPasswordByEmail",
    method: "post",
    data
  });
};
export const setPassword = data => {
  return axios.request({
    url: "/api/user/setPassword",
    method: "post",
    data
  });
};
export const dictList = params => {
  return axios.request({
    url: "/api/codeDict/list",
    method: "get",
    params
  });
};
export const getEncText = data => {
  return axios.request({
    url: "/api/sso/decrypt",
    method: "post",
    data
  });
};
export const checkPasswordValidity = data => {
  return axios.request({
    url: "/api/sso/checkPasswordValidity",
    method: "post",
    data
  });
};
export const setPasswordEmpty = data => {
  return axios.request({
    url: "/api/user/setPasswordEmpty",
    method: "post",
    data
  });
};
export const checkUUID = uuid => {
  return axios.request({
    url: getServerConfigUrl("VUE_APP_IWORKAPI", "/api/sso/check"),
    method: "get",
    params: {
      uuid
    }
  });
};
export const bindNew = data => {
  return axios.request({
    url: getServerConfigUrl("VUE_APP_IWORKAPI", "/api/v2/login/passwordLoginDownstream"),
    method: "post",
    data
  });
};

//给当前uuid设置语言
export const checkLanguage = (uuid, language) => {
  return axios.request({
    url: "/api/sso/configCheckLanguage",
    method: "get",
    params: {
      uuid,
      language
    }
  });
};
export const initPassword = body => {
  return axios.request({
    url: "/api/user/initPassword",
    method: "post",
    data: body
  });
};